import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { HelperService, HTTPService } from 'app/services';

import { sortBy } from 'lodash';

@Component({
  selector: 'app-rd-specs',
  templateUrl: './rd-specs.component.html',
  styleUrls: ['./rd-specs.component.scss'],
})
export class RdSpecsComponent implements OnInit, OnChanges {
  @Input() options: any = {};
  @Input() vehicleId: string = '';
  @Input() specifications: any[] = [];
  @Input() fluids: any[] = [];
  @Input() isProcessing: boolean = false;

  isSpecsSelected: boolean = false;
  isLoading: boolean = false;
  selectedSpecs = {
    type: '',
    liternalName: '',
    description: '',
    items: [],
    documents: [],
  };
  defaultHeaders: any = {
    fluid: {
      grade: { name: 'Fluid Type', value: 'grade', order: 0 },
      temp: { name: 'Temperature(°C)', value: 'temp', order: 1 },
      unitOfMeasure: {
        name: 'Unit Of Measure',
        value: 'unitOfMeasure',
        order: 2,
      },
      viscosity: { name: 'Viscosity', value: 'viscosity', order: 3 },
      specStandard: { name: 'Spec. Standard', value: 'specStandard', order: 4 },
      tradeName: { name: 'Trade name', value: 'tradeName', order: 5 },
      notes: { name: 'Note', value: 'notes', order: 6 },
    },
    spec: {
      value: { name: 'Value', value: 'value' },
      unitOfMeasure: { name: 'Unit Of Measure', value: 'unitOfMeasure' },
      minValue: { name: 'Min Value', value: 'minValue' },
      maxValue: { name: 'Max Value', value: 'maxValue' },
      includeFilter: { name: 'Include Filter', value: 'includeFilter' },
      stage: { name: 'Stage', value: 'stage' },
      notes: { name: 'Note', value: 'notes' },
    },
  };
  headers: any[] = [];
  documentUrls: any[] = [];
  imageIndex: number = 0;
  config = {
    btnClass: 'default',
    zoomFactor: 0.1,
    containerBackgroundColor: '#ccc',
    wheelZoom: true,
    allowFullscreen: true,
    allowKeyboardNavigation: true,
    btnIcons: {
      zoomIn: 'fal fa-search-plus',
      zoomOut: 'fal fa-search-minus',
      next: 'fas fa-caret-right',
      prev: 'fas fa-caret-left',
      fullscreen: 'fal fa-expand',
    },
    btnShow: {
      zoomIn: true,
      zoomOut: true,
      next: true,
      prev: true,
    },
  };
  selectedFluid: any = {};

  constructor(private httpService: HTTPService, private helperService: HelperService) {}

  ngOnInit() {
    this.fetchInitialDetails();
  }

  ngOnChanges(change: any) {
    const { isProcessing } = change;
    if (isProcessing) {
      if (isProcessing.previousValue && !isProcessing.currentValue) {
        this.fetchInitialDetails();
      }
    }
  }

  fetchInitialDetails() {
    if (this.isLoading) return;

    if (this.fluids.length) {
      this.selectedFluid = this.fluids[0];
      this.getSpecDetails(this.fluids[0].applicationId, 'fluid');
    } else if (this.specifications.length) {
      this.selectedFluid = this.specifications[0];
      this.getSpecDetails(this.specifications[0].applicationId, 'spec');
    }
  }

  getSpecDetails(id: string, type: string) {
    this.documentUrls = [];
    this.imageIndex = 0;
    this.isLoading = true;
    this.httpService
      .getComponentSpecsDetail({
        type,
        ...this.options,
        applicationId: id,
        vehicleId: this.vehicleId,
      })
      .then(
        ({ specDetails, documents }) => {
          if (specDetails && specDetails.length) {
            this.headers = this.defaultHeaders[type];
            this.selectedSpecs = {
              type,
              liternalName: specDetails[0].liternalName,
              description: specDetails[0].description,
              items: specDetails[0].items,
              documents: specDetails[0].documents,
            };

            this.setTableHeaders(type);
          }

          if (documents && documents.length) {
            this.documentUrls = documents.map(({ image }) => image);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoading = false;
      });
  }

  setTableHeaders(type: string) {
    const headers = {};

    this.selectedSpecs.items.forEach((data) => {
      Object.keys(data).forEach((key) => {
        if (data[key] && this.defaultHeaders[type][key]) {
          headers[key] = this.defaultHeaders[type][key];
        }
      });
    });

    this.headers = sortBy(Object.values(headers), 'order');
  }

  handleBack() {}
}
